import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

export default function LogoHori({ width = '100px', widthPx }) {
    const theme = useContext(ThemeContext);

    const logoSrc = theme.images.logoFullHorizontalTransparentSvg;
    const finalWidth = widthPx ? `${widthPx}px` : width;

    return (
        <>
            <img src={logoSrc} alt="EZSplit Logo" style={{ width: finalWidth }} />
        </>
    );
}
